"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[510],{

/***/ 9510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ RotatingNumber; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


function RotatingNumber(_ref) {
  var number = _ref.number,
      length = _ref.length,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 50 : _ref$interval,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1500 : _ref$duration;
  var el = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var random = Math.floor(Math.random() * 1000).toString().padStart(length, '0');

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(random),
      counter = _useState[0],
      setCounter = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var myInterval = setInterval(function () {
      var random = Math.floor(Math.random() * 1000).toString().padStart(length, '0');
      setCounter(random);
    }, interval); // Stop after 3 seconds

    setTimeout(function () {
      clearInterval(myInterval);
      setCounter(number);
    }, duration);
    return function () {
      return clearInterval(myInterval);
    };
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
    ref: el,
    children: counter
  });
}

/***/ })

}]);